import React from "react";
import { TextField, Alert, Button, Box } from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { AuthLayout } from "../../../shared/components/layout/AuthLayout";
import ForgotPasswordIllustration from "../../../assets/illustrations/forgot-pass.svg";
import { VALIDATOR_REQUIRE, VALIDATOR_EMAIL } from "../../../shared/utils/validators";
import FormButton from "../../../shared/components/ui/FormButton";

const ForgotPasswordView = ({
  forgotFormState,
  forgotInputHandler,
  handleTextInputChange,
  handleForgotPassword,
  loginState,
  setLoginState,
  isActionLoading,
  textFieldStyle,
}) => {
  return (
    <AuthLayout
      title="Forgot Your Password?"
      subtitle="Don't worry, happens to all of us. Enter your email below to recover your password"
      illustration={ForgotPasswordIllustration}
    >
      <div className="space-y-6">
        <Button
          onClick={() => setLoginState({ state: "login", message: null })}
          className="flex items-center gap-2 text-primary hover:opacity-80"
        >
          <ArrowBackIosNew fontSize="small" />
          <span className="text-sm font-medium">Back To Login</span>
        </Button>

        {loginState.message && (
          <Alert
            severity="info"
            className="mb-2"
            onClose={() => setLoginState({ state: "forgot", message: null })}
          >
            {loginState.message}
          </Alert>
        )}

        <Box
          component="form"
          onSubmit={handleForgotPassword}
          className="space-y-1"
        >
          <TextField
            label="Email"
            name="email"
            type="email"
            value={forgotFormState.inputs.email.value}
            onChange={(e) =>
              handleTextInputChange(e, forgotInputHandler, [
                VALIDATOR_REQUIRE(),
                VALIDATOR_EMAIL(),
              ])
            }
            placeholder="john.doe@gmail.com"
            variant="outlined"
            fullWidth
            required
            sx={{
              ...textFieldStyle,
              "& .MuiOutlinedInput-root": {
                borderRadius: "6px",
              },
            }}
            focused
          />

          <FormButton
            type="submit"
            variant="contained"
            fullWidth
            size="medium"
            sx={{
              backgroundColor: "#011a3c",
              height: "48px",
              fontWeight: 700,
              letterSpacing: "0.5px",
            }}
            loading={isActionLoading}
          >
            SUBMIT
          </FormButton>
        </Box>

        <div className="text-center mt-6 text-sm">
          <span>Don't Have An Account? </span>
          <span
            onClick={() => setLoginState({ state: "signup", message: null })}
            className="text-primary font-bold hover:underline cursor-pointer"
          >
            Sign Up
          </span>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPasswordView;
